import { productsRoute, rugsRoute } from '@/app/products/list/products.page.tsx';
import { productViewRoute } from '@/app/products/view/product-view-page.tsx';

export const productRoutes = [productsRoute, productViewRoute, rugsRoute];
